"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarginTypeSelect = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const legacy_1 = require("../Select/legacy");
class MarginTypeSelect extends react_1.default.PureComponent {
    render() {
        return react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { ...this.props });
    }
}
exports.MarginTypeSelect = MarginTypeSelect;
MarginTypeSelect.defaultProps = {
    items: [
        {
            name: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Field/LanguageSelect/Name:Percent', defaultMessage: 'Percent' })),
            value: 'percent',
        },
        {
            name: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Field/MarginTypeSelect/Name:CHF', defaultMessage: 'CHF' })),
            value: 'money',
        },
    ],
    label: null,
    value: undefined,
    placeholder: null,
};
//# sourceMappingURL=index.js.map